import React from 'react'
import { Switch, Route } from 'react-router-dom'

import FeedbackIndex from '@/pages/Feedback/FeedbackIndex'
import FeedbackShow from '@/pages/Feedback/FeedbackShow'
import FeedbackNew from '@/pages/Feedback/FeedbackNew'

const FeedbackContainer = () => (
  <Switch>
    <Route exact path='/feedback/new'><FeedbackNew /></Route>
    <Route exact path='/feedback/:slug'><FeedbackShow /></Route>
    <Route exact path='/feedback'><FeedbackIndex /></Route>
  </Switch>
)

export default FeedbackContainer
